import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Prescriber } from 'src/app/shared/models/services-aide-emploi/prescriber';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-prescriber-signup',
	templateUrl: './prescriber-signup.component.html',
	styleUrls: ['./prescriber-signup.component.scss']
})
export class PrescriberSignupComponent implements OnInit {
	signupForm = new FormGroup({
		fullName: new FormControl('', [
			Validators.required,
			Validators.pattern('^[a-zA-Zà-ÿÀ-Ÿ0-9 ]*$')
		]),
		email: new FormControl('', [Validators.required, Validators.email]),
		phone: new FormControl('', [
			Validators.required,
			Validators.pattern('^\\+?[0-9]\\d{1,14}$')
		]),
		professionalProof: new FormControl('')
	});

	// siteKey: string;
	// captchaToken: string;
	// token: string;

	errorMessage: string | null = null; // Variable pour stocker le message d'erreur
	successMessage: string | null = null; // Variable pour stocker le message de succès

	constructor(private facade: FacadeService, private logger: LogService) {}

	ngOnInit(): void {
		// this.siteKey = environment.recaptcha.siteKey;
	}

	// resolved(captchaResponse: string) {
	// 	this.logger.info(`Resolved captcha with response: ${captchaResponse}`);
	// 	this.captchaToken = captchaResponse;
	// }

	// onError(log: any) {
	// 	this.logger.info('error ', log);
	// }

	onSubmit() {
		this.errorMessage = null; // Réinitialiser le message d'erreur à chaque soumission
		this.successMessage = null;

		if (this.signupForm.valid) {
			console.log(this.signupForm.value);

			// process the form

			const prescriber = new Prescriber({
				name: this.signupForm.value.fullName,
				email: this.signupForm.value.email,
				phone: this.signupForm.value.phone,
				professionalProof: this.signupForm.value.professionalProof
			});

			//prescriber.recaptchaToken = this.captchaToken;
			this.facade.prescriberService.registerPrescriber(prescriber).subscribe({
				next: (v) => {
					if (v.response === 'Le prescripteur a été ajouté.') {
						this.successMessage =
							"Inscription enregistrée, un e-mail d'activation a été envoyé pour vérifier votre compte.";
						this.signupForm.reset(); // Réinitialiser le formulaire
					}
				},
				error: (e) => {
					if (e.error?.response?.includes('email')) {
						// Vérifier le message d'erreur spécifique
						this.errorMessage =
							"L'adresse email est déjà utilisée. Veuillez en utiliser une autre.";
					}
				}
			});
		}
	}
}
